import { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { InView } from 'react-intersection-observer';
import Controls from './controls/Controls';

import styles from './StickyControls.module.scss';
import { useStickyControlsData } from './data/useStickyControlsData';
import { usePlpViewType } from '../../hooks/usePlpViewType';

const StickyControls = ({ ...props }) => {
  const { isHeaderPeeping, isProductCardSizeFlagOn, isSingleColumnLayout } =
    useStickyControlsData();
  const { hasPlpViewTypeSelection } = usePlpViewType('useStickyControlsData');

  return (
    <InView initialInView>
      {({ inView, ref }) => (
        <Fragment>
          <div ref={ref} className={styles['sticky-sentinel']} />
          <div
            className={classNames(styles['sticky-controls'], {
              [styles.isHeaderPeeping]: isHeaderPeeping,
              [styles['sticky-controls--isStuck']]: !inView,
              [styles['sticky-controls--singleColumn']]: isSingleColumnLayout,
            })}
            data-testid="component-sticky-controls"
          >
            <div
              className={classNames(styles['sticky-controls__controls'], {
                [styles['sticky-controls__controls--isStuck']]: !inView,
                [styles['sticky-controls__controls--viewSelector']]:
                  hasPlpViewTypeSelection || isProductCardSizeFlagOn,
                [styles['sticky-controls__controls--singleColumn']]:
                  isSingleColumnLayout,
              })}
              data-testid="component-controls-container"
            >
              <Controls {...props} inView={inView} />
            </div>
          </div>
        </Fragment>
      )}
    </InView>
  );
};

StickyControls.propTypes = {
  isHeaderPeeping: PropTypes.bool,
  isProductCardSizeFlagOn: PropTypes.bool,
};

export default StickyControls;
